import {IBusinessAdminSavedStates, IBusinessSiteInfo, BusinessCategoryEnum, BusinessSizeEnum, CurrentBookingMethodEnum} from "@torim-app/types";
import {adminUrlBuilder} from "@app/api/utils";

export class AdminApi {
  static readonly path = '';

  static async createBasicBusiness(
    body: IBusinessSiteInfo & { businessCategory?: BusinessCategoryEnum[]; businessSize?: BusinessSizeEnum; currentBookingMethod?: CurrentBookingMethodEnum }
  ): Promise<void> {
    const url = adminUrlBuilder({}, AdminApi.path);
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok)
      throw `Failed to create new business`;
  }

  static async validateBusiness(
    body: { verificationCode: string; metaEventId?: string }
  ): Promise<void> {
    const url = adminUrlBuilder({}, AdminApi.path);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok)
      throw `Failed to validate new business`;
  }

  static async resendVerificationCode(): Promise<void> {
    const url = adminUrlBuilder({}, 'resend-verification');
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
    });

    if (!response.ok)
      throw `Failed to resend verification code`;
  }

  static async removeAccount(): Promise<void> {
    const url = adminUrlBuilder({}, AdminApi.path);
    const response = await fetch(url, {
      method: 'delete',
      headers: {
        'content-type': 'application/json'
      },
    });

    if (!response.ok)
      throw `Failed to remove account`;
  }

  static async switchToFreePlan(): Promise<void> {
    const url = adminUrlBuilder({}, `free-plan`);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
    });

    if (!response.ok)
      throw `Failed to switch to free plan`;
  }

  static async updateState(state: Partial<IBusinessAdminSavedStates>): Promise<void> {
    const url = adminUrlBuilder({}, 'state');
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(state)
    });

    if (!response.ok)
      throw `Failed to update state`;
  }

  static async getRedirect(): Promise<{ redirect: 'admin' | 'customer' }> {
    const url = adminUrlBuilder({}, 'redirect');
    try {
      const response = await fetch(url, {
        method: 'get',
        headers: {'content-type': 'application/json'},
      });
      if (!response.ok) {
        throw `Failed to getCustomerAppointments`;
      }

      return (await response.json());
    } catch (e) {
      console.error(e)
      throw e;
    }
  }
}
